import { useState, useEffect } from "react";
import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useForumSections() {
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSections() {
      const { response, data } = await API.fetchForumSections();

      if (response.ok) {
        setResult(data);
        setLoading(false);
      }
    }

    fetchSections();
  }, []);

  return {
    sections: result ?? [],
    loading: loading,
  };
}